/** A value built once for each key object, made on the first ask for that key. */
/**
 * A reader that builds its value once for each key it is called with. The key is the object's
 * identity, so the caller keeps a key unchanged for as long as its value holds, or gives a `stamp`
 * that moves when it stops holding. The WeakMap lets an entry be collected with its key. A build
 * that throws stores nothing, so the next ask builds again.
 *
 * @canonical A cache keyed by an object
 *   It holds a WeakMap, and a build that throws stores nothing. Pass `keeps` for a value that is
 *   not final yet, and `stamp` for a key whose contents change, as a texture's `version`.
 */
export function perObject(build, { keeps, stamp = () => 0 } = {}) {
    const built = new WeakMap();
    return (key) => {
        const current = stamp(key);
        const stored = built.get(key);
        if (stored?.stamp === current)
            return stored.value;
        const value = build(key);
        if (!keeps || keeps(value, key))
            built.set(key, { stamp: current, value });
        return value;
    };
}
//# sourceMappingURL=perObject.js.map